"use client";

import React from "react";
import { FaCheckCircle } from "react-icons/fa";
import Container from "../Container";

const savings = [
  { task: "Set up Prisma database", hours: 6 },
  { task: "Apply for Google OAuth credentials", hours: 2 },
  { task: "Secure API routes for buyers/sellers", hours: 4 },
  { task: "Set up emails with Resend", hours: 6 },
  { task: "Stripe webhook + invoices + emails", hours: 10 },
  { task: "Set up sitemap generator and PSEO", hours: 4 },
  { task: "Set up currency converter logic", hours: 4 },
  { task: "Set up forms with CAPTCHA protection", hours: 4 },
  { task: "Set up cron jobs for automated tasks", hours: 4 },
  { task: "Set up admin panel", hours: 8 },
  { task: "Set up extensive components", hours: 8 },
  { task: "Design a responsive P2P architecture", hours: 10 },
  { task: "Generate ChatGPT prompts", hours: 2 },
  { task: "Overthink P2P architecture", hours: "∞" },
];

const SavingsBreakdown = () => {
  const totalTaskHours = savings
    .filter((item) => typeof item.hours === "number")
    .reduce((sum, item) => sum + (item.hours as number), 0);

  return (
    <section className="py-20 bg-black text-white">
      <Container>
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
          Hours You Save with Peerquik Next.js boilerplate
        </h2>
        <div className="max-w-md mx-auto">
          <div className="bg-gray-900 p-6 rounded-lg shadow-md border-t-4 border-cyan-400">
            <p className="text-gray-300 text-base leading-relaxed mb-6">
              Peerquik saves you <strong>{totalTaskHours}+ hours</strong> on key setup tasks and{" "}
              <strong>500+ hours</strong> building your C2C/B2C marketplace with 23 pre-built features.
              That’s weeks of work and $15,000+ in labor costs!
            </p>
            <ul className="space-y-3">
              {savings.map((item, index) => (
                <li key={index} className="flex items-start">
                  <FaCheckCircle className="text-cyan-400 mr-3 mt-1 flex-shrink-0" />
                  <span className="text-gray-300 text-sm leading-snug">
                    <strong>{item.hours} hrs</strong> to {item.task}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default SavingsBreakdown;
